import React, { useContext, useState } from "react"
import FullScreenLoader from "../FullScreenLoader"
import MemoHeader from "./MemoHeader"
import { useMemoData } from "hooks/useMemoData"
import MemoBody from "./MemoBody"
import { AuthContext } from "context/AuthContext"

function parseJSON(jsonData,defaultValue){
	try {
		return JSON.parse(jsonData)
	} catch (error) {
		return defaultValue
	}
}

const MemoDetails = () => {
	const {adminProfile} = useContext(AuthContext)
	const {loading,memo,selectLoan,selectedLoans,refetch} = useMemoData()
	const [toggleMsg, setToggleMsg] = useState(false)

	const toggleHandler = () => {
		setToggleMsg(!toggleMsg)
	}
	
	if(loading){
		return <FullScreenLoader show={true} />
	}
	if(!memo) return null;

	const loans =  !loading && parseJSON(memo.applications,[])
	return (
		<section className="">
			<MemoHeader
				memo={memo}
				refetch={refetch}
				hasThreads={memo.threads.length > 0 }
				adminRole={memo.admin.admin_role}
				toggleMemo={toggleHandler}
				selectedLoans={selectedLoans}
			/>
			<div className="my-7">
				<p className="text-center mt-4 my-8 text-xl">MEMO RESPONSE THREAD</p>
				<MemoBody
					selectLoan={selectLoan}
					refetch={refetch}
					selectedLoans={selectedLoans}
					hasThreads={memo.threads.length > 0}
					singleMemo={memo} loans={loans}
					adminRole={adminProfile?.admin_role}/>
			</div>
		</section>
	)
}

export default MemoDetails
